export default __webpack_public_path__ + "static/media/before-footer-img7.6bb4779e.png";